// Local translations
export const T = {
  en_GB: {
    showChart: "Show Chart",
    showChartDesc: "Display the pie chart visualization",
    showTable: "Show Table",
    showTableDesc: "Display data table with color indicators",
    enableFollowupComparison: "Enable comparison in follow up sessions",
    enableFollowupComparisonDesc:
      "Show existing vs modified portfolio side-by-side when the session is a followup",
    atLeastOneOption: "At least one display option must be selected",
  },
  nb_NO: {
    showChart: "Vis diagram",
    showChartDesc: "Vis sektordiagramvisualisering",
    showTable: "Vis tabell",
    showTableDesc: "Vis datatabell med fargeindikatorer",
    enableFollowupComparison: "Aktiver sammenligning i oppfølgingsøkter",
    enableFollowupComparisonDesc:
      "Vis eksisterende og endret portefølje side om side når økten er en oppfølging",
    atLeastOneOption: "Minst ett visningsalternativ må være valgt",
  },
} as const;
